import React, { FC } from 'react'
import { Typography } from 'transfix-ui/core'
import { ConfirmationModal } from 'transfix-ui'
import { IMotorCarrier } from '../types'

export interface ITestCarrierProdBookingModal {
  isOpen: boolean
  onSubmit: () => void
}

interface ITestCarrierProdBookingModalProps {
  onClose: () => void
  isOpen: boolean
  onSubmit: () => void
}

export const isTestCarrier = (motorCarriers: IMotorCarrier[]) => {
  return __PROD__ && motorCarriers.some(mc => mc.legalName.toLowerCase().includes('do not use'))
}

export const TestCarrierProdBookingModal: FC<ITestCarrierProdBookingModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
}) => {
  const confirmHandler = () => {
    onSubmit()
    onClose()
  }

  return (
    <ConfirmationModal
      title='You are in Production'
      size={3}
      open={isOpen}
      actions={[
        {
          label: 'Cancel',
          type: 'dismiss',
          action: onClose,
        },
        {
          label: 'Proceed',
          type: 'confirm',
          action: confirmHandler,
        },
      ]}
      onClose={onClose}>
      <Typography variant='body1' component='div'>
        You are about to bid or book on a load in production with a test carrier. Are you sure you
        want to proceed?
      </Typography>
    </ConfirmationModal>
  )
}
